import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { IShareBarProps } from './ShareBar.i';
import { LazyLoadContext } from '@riac/core';
import { cn } from '../cn';
import { Button } from '../Button';
import { IconTwitter, IconPrint, IconFacebook, IconPinterest } from '../Icons';

export const ShareBar = ({ title, text, image, buttonClassName }: IShareBarProps) => {
  const location = useLocation();
  const currentUrl = `https://www.rockislandauction.com${location.pathname}`;
  const { setForceLoad } = useContext(LazyLoadContext); // TODO: Force load before printing!!!

  const handleShare = (site: string) => {
    switch (site) {
      case 'facebook':
        return window.open(
          `https://www.facebook.com/sharer/sharer.php?app_id=1694870180767912&kid_directed_site=0&sdk=joey&u=${encodeURIComponent(currentUrl)}&display=popup&ref=plugin&src=share_button`,
          'Facebook Share',
          'width=600,height=420'
        );
      case 'twitter':
        return window.open(
          `https://twitter.com/intent/tweet?ref_src=twsrc%5Etfw&text=${title}&tw_p=tweetbutton&url=${encodeURI(currentUrl)}`,
          'Twitter Share',
          'width=600,height=420'
        );
      case 'pinterest':
        return (window as any).PinUtils.pinOne({
          'url': currentUrl,
          'media': image,
          'description': `${title}`,
        });
      case 'print':
        window.print();
    }
  };

  const defaultCN = 'hover:text-text flex items-center justify-center h-10 w-10';

  return (<>
    <Button className={cn(defaultCN, buttonClassName)} unstyled onPress={() => handleShare('print')} aria-label='Print'><IconPrint/></Button>
    <Button className={cn(defaultCN, buttonClassName)} unstyled onPress={() => handleShare('twitter')} aria-label='Twitter'><IconTwitter/></Button>
    <Button className={cn(defaultCN, buttonClassName)} unstyled onPress={() => handleShare('facebook')} aria-label='Facebook'><IconFacebook/></Button>
    <Button className={cn(defaultCN, buttonClassName)} unstyled onPress={() => handleShare('pinterest')} aria-label='Pinterest'><IconPinterest/></Button>
  </>);
};
